class StatusBar{
  constructor(){

  }
  

  // because media picker / camera picker and file picker forcing the
  // statusbarOverlayWebview=false...
  resetViewBugMessingThingsUp(){
    if(window.StatusBar){
      
     
      setTimeout(()=>{
        window.StatusBar.hide();
        setTimeout(()=>{
          window.StatusBar.show();
        },300);
      },300);  
      
    }
   
  }


}

export let statusBar = new StatusBar();